import React, { useState } from "react";
import RequestService from "../services/request.service";


import './registro.scss';

// // // // import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
// import { Button, Modal, Table, Form } from 'react-bootstrap'

import { useNavigate } from "react-router"


import { Formik } from 'formik';
import * as yup from 'yup';

import { toast } from 'react-toastify'



import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';


import Dialog from '../services/Dialogs'

// // // import { confirm } from '../../widgets/confirm'

// // import './mi_reporte.scss';

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";


import moment from 'moment'

// import Pagination from "../../services/Pagination";



// import { useNavigate } from "react-router-dom";
// // import EditarTramite from './Modales/editarTramite'
// // import EditarTramite from '../Reportes/Modales/editarTramite'


// // // import { SERVER_ } from  '../../config';

// // import AuthService from "../../features/auth/auth.service";

const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u


const RegistroUsuariosAsesores = () => {

	// const { Formik } = formik;

	const dialog = new Dialog()
  
  	const navigate = useNavigate();

	const [ sucursales, setSucursales] = useState<any>([{ gerentes : [] }])

	const cargarGerentes = async() => {

		try{
			let res = await RequestService.getEndPoint('registro/lista_gerentes')
			// console.log(res.data)
			setSucursales(res.data)
		}
		catch(e){
			toast.error('Tuvimos problemas al cargar la lista de Gerentes')
		}

	}


  React.useEffect(() => {
    cargarGerentes()
  }, []);


  // const [validated, setValidated] = useState(false);

  // const handleSubmit = async (event:any) => {
  //   const form = event.currentTarget;
  //     event.preventDefault();
  //     event.stopPropagation();
    
  //   if (form.checkValidity() === false) {
  //   	console.log(0)
  //   	console.log('ah?')
  //   }
  //   else{
  //   	console.log(1)

		// //   	console.log(event)
		// //   	console.log(form)
		// //   	const formData = new FormData(form)
		// //   	console.log(formData)
		// //   	console.log(formData.values()); // foo
  // // for (const value of formData.values()) {
  // //   console.log(value);
  // // }
		// //   	console.log('si se envia al final')
		//   }
  //   }
    
  // };

var mensaes_validacion_generico = 'Este campo es obligatorio'


const schema = yup.object().shape({


	// # id, uuid, activo, 
	username: yup.string().required(mensaes_validacion_generico).matches(/^[a-zA-Z0-9]+$/,'La contraseña solo puede tener letras y números. No se aceptan espacios ni caracteres especiales'),
	pwd: yup .string().required('La contraseña es obligatoria') .matches( /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, "Debe contener 8 carácteres, 1 mayúscula, 1 minúscula, 1 número y un caracter especial como: * ! % $ & " ),
	  changepassword: yup.string().required().when("pwd", {
	    is: val => (val && val.length > 0 ? true : false),
	    then: yup.string().oneOf(
	      [yup.ref("pwd")],
	      "Las contraseñas NO coinciden"
	    )
	  }),
	curp: yup.string().required(mensaes_validacion_generico).matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
	email: yup.string().required(mensaes_validacion_generico).email('Formato de Email no valido').required('Este campo es obligatorio'),
	celular: yup.string().required(mensaes_validacion_generico).matches(/^\d{10}$/,"Formato no valido"),

	nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
	paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required(mensaes_validacion_generico),
	materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),
	// idsucursal: yup.string().required(),
	// idsucursal: yup.number().required(),
	idgerente: yup.string().required(mensaes_validacion_generico),


  // firstName: yup.string().required(),
  // lastName: yup.string().required(),
  // username: yup.string().required(),
  // city: yup.string().required(),
  // state: yup.string().required(),
  // zip: yup.string().required(),
  terms: yup.bool().required().oneOf([true], 'Los terminos y condiciones deben ser aceptadas'),
});

const [ envio_server, setSeEnvio ] = useState<boolean>(false)

const enviarFormulario = async (nuevo_usuario:any,event:any,) =>{
		  await dialog.open({
		    accept: 'Crear Usuario',
		    cancel: 'Espera',
		    dialogClass: '',
		    message: '¿Estás seguro de la información?',
		    // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
		    // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
		    target: event.target,
		    template: `
					<dl>
					  <dt>Nombre</dt>
					  <dd>`+nuevo_usuario.nombres+` `+nuevo_usuario.paterno+` `+nuevo_usuario.materno+`</dd>
					  <dt>CURP</dt>
					  <dd>`+nuevo_usuario.curp+`</dd>
					  <dt>Celular</dt>
					  <dd>`+nuevo_usuario.celular+`</dd>
					  <dt>Correo Electrónico</dt>
					  <dd>`+nuevo_usuario.email+`</dd>
					  <dt>Gerente</dt>
					  <dd>`+dameAlGerenteDeEsteUUID(nuevo_usuario.idgerente)+`</dd>
					</dl>
		    `
		  })
		  let dialogo : any = await dialog.waitForUser()
		  if(dialogo){
		  	setSeEnvio(true)
			console.log('lo que se envia es:', nuevo_usuario)
		  	let res_nuevo_usuario = await RequestService.create('registro/crear_usuario', nuevo_usuario)

		  	if(res_nuevo_usuario){
			  	toast.success('Tu registro se realizo correctamente, ahora puede acceder a la plataforma Gesti+ CRM')
			  	setTimeout(()=>{
			  		navigate('/')	
			  	},3000)
			  }
			  else{
			  	toast.error('Error al crear usuario en el servidor')
			  }	
		  	
		  }
		 
}

const curp2date = (curp:any) => {
	var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
	//miFecha = new Date(año,mes,dia) 
	var anyo = parseInt(m[1],10)+1900;
	if( anyo < 1950 ) anyo += 100;
	var mes = parseInt(m[2], 10)-1;
	var dia = parseInt(m[3], 10);
	return moment(new Date( anyo, mes, dia )).format('YYYY-MM-DD');
}

const dameAlGerenteDeEsteUUID = (uuid_gerente:string)=>{
	let nombre_gerente = ""
	for (var i = 0; i < sucursales.length; ++i) {
		for (var j = 0; j < sucursales[i].gerentes.length; ++j) {
			// code...
			if(sucursales[i].gerentes[j].uuid === uuid_gerente) nombre_gerente = sucursales[i].gerentes[j].nombres + ' ' + sucursales[i].gerentes[j].paterno + ' ' + sucursales[i].gerentes[j].materno 
		}
	}
	return nombre_gerente
}

	return (

		<React.Fragment>
			



    <div id="login-overlay" className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
	          <h4 className="modal-title" id="myModalLabel">Gesti+</h4>
	          <p style={{marginBottom:0}}>Registro de Usuario</p>
	    </div>
    	<div className="modal-body">
          


    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

			username:  "",

			pwd:  "",
			changepassword:  "",

			celular:  "",
			email:  "",

			curp:  "",
			nombres:  "",
			paterno:  "",
			materno:  "",

			// idsucursal:  "",
			idgerente:  "",

        // firstName: 'Mark',
        // lastName: 'Otto',
        // username: '',
        // city: '',
        // state: '',
        // zip: '',
        terms: false,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>

        

        	<h5>Información Personal</h5>

          <Row >
            <Form.Group as={Col} md="4" className="mb-3" controlId="nombres">
              <Form.Label>Nombre(s)</Form.Label>
              <Form.Control
                type="text"
                required
                name="nombres"
                value={values.nombres}
                onChange={(e)=>{ setFieldValue('nombres', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.nombres}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.nombres} </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="paterno">
              <Form.Label>Apellido Paterno</Form.Label>
              <Form.Control
                type="text"
                required
                name="paterno"
                value={values.paterno}
                onChange={(e)=>{ setFieldValue('paterno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.paterno}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.paterno} </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="materno">
              <Form.Label>Apellido Materno</Form.Label>
              <Form.Control
                type="text"
                name="materno"
                value={values.materno}
                onChange={(e)=>{ setFieldValue('materno', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.materno}
              />

              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.materno} </Form.Control.Feedback>
            </Form.Group>
          </Row>



          <Row >
            <Form.Group as={Col} md="6" className="mb-3" controlId="curp">
              <Form.Label>CURP </Form.Label>
              <Form.Control
                type="text"
                required
                name="curp"
                value={values.curp}
                onChange={(e)=>{ setFieldValue('curp', (e.target.value || "").toUpperCase()) }}
                isInvalid={!!errors.curp}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
			  <Form.Control.Feedback type="invalid"> {errors.curp	} </Form.Control.Feedback>
            </Form.Group>
            <Col md="3">
            	{ 
	            	REG_CURP.test(values.curp) &&(
					    <div className="mb-3">
					      <label className="form-label">Sexo</label>
					      <input type="text" readOnly value={values.curp.substr(10,1)==='H'?'HOMBRE':'MUJER'} className="form-control" />
					    </div>
	            	)
	            }
            </Col>
            <Col md="3">
            	{ 
	            	REG_CURP.test(values.curp) &&(
					    <div className="mb-3">
					      <label className="form-label">Fecha de Nacimiento</label>
					      <input type="text" readOnly value={curp2date(values.curp)} className="form-control" />
					    </div>
	            	)
	            }
            </Col>
          </Row>


          <hr/>


          <h5>Información de Contacto</h5>



          <Row>
            <Form.Group as={Col} md="7" className="mb-3" controlId="email">
              <Form.Label>Correo Electrónico</Form.Label>
              <Form.Control
                type="email"
                required
                name="email"
                value={values.email}
                onChange={(e)=>{ setFieldValue('email', e.target.value ) }}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.email} </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="5" className="mb-3" controlId="celular">
              <Form.Label>Celular</Form.Label>
              <Form.Control
                type="text"
                required
                name="celular"
                value={values.celular}
                onChange={(e)=>{ setFieldValue('celular',e.target.value) }}
                isInvalid={!!errors.celular}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.celular} </Form.Control.Feedback>
            </Form.Group>
          </Row>


          <hr/>

          <h5>Información de Usuario</h5>



          <Row>
            <Form.Group as={Col} md="4" className="mb-3" controlId="username">
              <Form.Label>Nombre de Usuario</Form.Label>
              <Form.Control
                type="text"
                required
                name="username"
                value={values.username}
                onChange={(e)=>{ setFieldValue('username', e.target.value ) }}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.username} </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="pwd">
              <Form.Label>Contraseña para el acceso</Form.Label>
              <Form.Control
                type="password"
                required
                name="pwd"
                value={values.pwd}
                onChange={(e)=>{ setFieldValue('pwd',e.target.value) }}
                isInvalid={!!errors.pwd}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.pwd} </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-3" controlId="changepassword">
              <Form.Label>Confirma tú contraseña</Form.Label>
              <Form.Control
                type="password"
                required
                name="changepassword"
                value={values.changepassword}
                onChange={(e)=>{ setFieldValue('changepassword',e.target.value) }}
                isInvalid={!!errors.changepassword}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.changepassword} </Form.Control.Feedback>
            </Form.Group>
          </Row>


			    	{
			    			// JSON.stringify(sucursales)
			    	}


          <Row>
            <Form.Group as={Col} md="6" className="mb-3" controlId="idgerente">
              <Form.Label>Selecciona a tú gerente</Form.Label>
			    <Form.Select required name="idgerente" value={values.idgerente} onChange={(e)=>{ setFieldValue('idgerente', e.target.value ) }} isInvalid={!!errors.idgerente}>
			    	<option disabled={values.idgerente!==''} value="">SELECCIONA UN GERENTE</option>
			    	{
			    		sucursales.map( sucursal =>
			    			<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
								  <optgroup  label={sucursal.nombre_sucursal}>
								  	{
								  		sucursal.gerentes.map( gerente =>
								  			<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
								  				<option value={gerente.uuid}> {gerente.nombres} {gerente.paterno} {gerente.materno}</option>
								  			</React.Fragment>
								  		)
								  	}
								  </optgroup>
			    			</React.Fragment>
			    		)
			    	}

			    </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
				<Form.Control.Feedback type="invalid"> {errors.idgerente} </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <br/>
          <br/>

          <h6 className="mt-4">POLÍTICAS DE PRIVACIDAD, PROTECCIÓN DE DATOS PERSONALES Y TERMINOS Y CONDICIONES</h6>
          <p>El tratamiento de sus datos personales se limitará al cumplimiento de la finalidad establecida en el aviso de privacidad de la aplicación.</p>
          <p>Únicamente los Usuarios expresamente autorizados por <b>Gesti+ Corporativo</b> podrán acceder y usar la plataforma <b>Gesti+ CRM</b>. Los Usuarios que no dispongan de autorización, no podrán acceder a dicho contenido.</p>
          <p>Usted asume la responsabilidad de todas las acciones que ejecute, en la utilización y consulta de <b>Gesti+ CRM</b>. Usted no utilizará, ni permitirá que otros usuarios utilicen esta aplicación móvil o cualquier servicio prestado a través de ella, de forma contraria a lo establecido en estos “Términos y Condiciones de Uso”, así como a las disposiciones legales aplicables a los servicios que ofrece la aplicación <b>Gesti+ CRM</b>. Es responsabilidad de usted todo acto que se realice en esta aplicación de software, por medio de su “Nombre de Usuario” y “Contraseña”; asimismo, usted se responsabiliza del cuidado y custodia de los mismos, para que esta aplicación de software únicamente sea utilizada para los fines para los cuales ha sido diseñada, por lo que cualquier mal uso que se realice en su nombre, se presumirá realizada por usted.</p>
          <p>Usted reconoce y acepta que <b>Gesti+ Corporativo</b> queda liberado de toda responsabilidad por el mal uso que llegara a realizarse en alguno de los módulos de la <b>Gesti+ CRM</b> y podrá tomar acción legal si en su caso lo procede.</p>
          <p>En ningún caso el <b>Gesti+ Corporativo</b> será responsable por las consecuencias del uso indebido o fraudulento de la plataforma de software <b>Gesti+ CRM</b>, cualquiera que sea la causa del eventual daño.</p>
          <p>El uso de la <b>Gesti+ CRM</b>, no lo convierte a usted en titular de ninguno de los derechos de propiedad intelectual del mismo, ni del contenido o información a la que acceda. Queda prohibido utilizar el nombre, la marca o el logotipo del mismo, así como la de <b>Gesti+ Corporativo</b>. Asimismo, no se podrá eliminar, ocultar ni alterar los avisos legales que se muestran en la misma. Sin perjuicio de lo anterior, usted podrá imprimirlos, copiarlos o almacenarlos, siempre y cuando sea para uso estrictamente personal.</p>

          <Form.Group className="mb-3">
            <Form.Check
              required
              name="terms"
              label="Acepto los terminos y condiciones"
              onChange={handleChange}
              isInvalid={!!errors.terms}
              feedback={errors.terms}
              feedbackType="invalid"
              id="validationFormik0"
            />
          </Form.Group>

          {
          	!false && (
          			<Button className="btn-lg" type="submit">Crear Usuario</Button>
          	)
          }
          
        </Form>
      )}
    </Formik>




    	</div>
  </div>
</div>


		</React.Fragment>

	)


}


export default RegistroUsuariosAsesores